
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c6.616 0 12 5.384 12 12s-5.384 12-12 12S4 22.616 4 16 9.384 4 16 4zm0 2c-.273 0-.545.041-.813.063l2.219.156.531 2.313-3 .563-.813-1.125-1.719.375.594 2.656-4 1.906-2.688 2.125.969 1.969h3.719l4.031 3.031-1.063 4 1.094 1.906c.307.028.623.063.938.063 1.542 0 3.01-.349 4.313-.969l1.594-5s-.737-1.813-.844-1.813-2.094.344-2.094.344l-1.938-1.594.969-3 1.719-1.281 1.75-.25 1.625 1 .688-1.25-2.688-.875-2.156.688-.156-2.063.875-.75 1.063.469-.188-2 .813-.094A9.974 9.974 0 0016 6zm-1.125.063a9.909 9.909 0 00-2.313.531l.75.125zM6.063 16.781c.315 4.108 3.068 7.526 6.844 8.75l-2.844-3.5H8.907l-1.875-2.063v-2.063z"}})])
          )
        }
      }
    